export default "__VITE_ASSET__4963ca7e__"